// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3512":"1f517d9a","9575":"1f517d9a"}[chunkId] + ".chunk.css";
};